// src/hooks/usePermissionModal.js
import {useCallback, useState} from 'react';
import toast from 'react-hot-toast';

export const usePermissionModal = () => {
  const [jobPermissionModalOpen, setJobPermissionModalOpen] = useState(false);
  const [selectedWorkspaceId, setSelectedWorkspaceId] = useState(null);
  const [selectedUserId, setSelectedUserId] = useState(null);
  const [selectedJobForPermission, setSelectedJobForPermission] = useState(null);

  const openPermissionModal = useCallback((job, workspaceId, userId) => {
    if (!workspaceId) {
      toast.error('Cannot manage permissions: Workspace ID not found');
      return;
    }
    if (!userId) {
      toast.error('Cannot manage permissions: User ID not found');
      return;
    }
    setSelectedWorkspaceId(workspaceId);
    setSelectedUserId(userId);
    setSelectedJobForPermission(job);
    setJobPermissionModalOpen(true);
  }, []);

  const closePermissionModal = useCallback(() => {
    setJobPermissionModalOpen(false);
    setSelectedWorkspaceId(null);
    setSelectedUserId(null);
    setSelectedJobForPermission(null);
  }, []);

  return {
    jobPermissionModalOpen,
    selectedWorkspaceId,
    selectedUserId,
    selectedJobForPermission,
    openPermissionModal,
    closePermissionModal,
  };
};